(function(ss) {

  var encodeURIComponent = window.encodeURIComponent,

    // Service Names
    SERVICE_LINKEDIN = 'LinkedIn',
    SERVICE_TWITTER = 'Twitter',
    SERVICE_FACEBOOK = 'Facebook',
    SERVICE_PINTEREST = 'Pinterest',
    NORMALIZED_SERVICE_MAP = {
      'linkedin': SERVICE_LINKEDIN,
      'twitter': SERVICE_TWITTER,
      'facebook': SERVICE_FACEBOOK,
      'pinterest': SERVICE_PINTEREST
    },

    // Social Account Handles
    TWITTER_USER_SLIDESHARE = 'SlideShare',

    // Base Urls
    LINKEDIN_BASE_SHARE_URL = 'https://www.linkedin.com/shareArticle',
    TWITTER_BASE_SHARE_URL = 'https://twitter.com/intent/tweet',
    FACEBOOK_BASE_SHARE_URL = 'https://www.facebook.com/sharer/sharer.php',
    PINTEREST_BASE_SHARE_URL = 'https://pinterest.com/pin/create/button/',

    /**
     * A utility for generating a share url to a third party network.
     */
    socialShareUtil = {
      SERVICE_LINKEDIN: SERVICE_LINKEDIN,
      SERVICE_TWITTER: SERVICE_TWITTER,
      SERVICE_FACEBOOK: SERVICE_FACEBOOK,
      SERVICE_PINTEREST: SERVICE_PINTEREST,

      /**
       * Takes in an unnormalized service name and maps it to our local constants.
       * @param {String} serviceName a service name like e.g. 'LinkedIn', 'twitter', 'linkedin', facebook', 'Facebook'
       * @returns {String}           a normalized service name e.g. 'LinkedIn', 'Twitter', 'Facebook', 'GooglePlus'
       */
      getNormalizedServiceName: function(serviceName) {
        var key,
          normalizedServiceName;

        if (!serviceName) {
          throw new Error('Undefined service name: ' + serviceName);
        }

        key = serviceName.toLowerCase();
        normalizedServiceName = NORMALIZED_SERVICE_MAP[key];

        if (normalizedServiceName) {
          serviceName = normalizedServiceName;
        }

        return serviceName;
      },

      /**
       * Takes in a normalized service name and determines if we support share link generation for it.
       * @param {String} serviceName a service name e.g. 'LinkedIn', 'Twitter', 'Facebook', 'GooglePlus'
       * @returns {Boolean}
       */
      isSupportedService: function(serviceName) {
        return Object.keys(NORMALIZED_SERVICE_MAP).some(function(key) {
          return NORMALIZED_SERVICE_MAP[key] === serviceName;
        });
      },

      /**
       * Given an arbitrary url, generates a LinkedIn share window url.
       * @param {String} url Content url to share.
       * @param {Object} [opts] Meta information about url being shared. Will override any scraped meta from url.
       * @param {String} [opts.title] Title of content being shared.
       * @param {String} [opts.description] Description of content being shared.
       * @returns {String} A generated LinkedIn share window url.
       */
      generateLinkedInShareWindowUrl: function(url, opts) {
        var params = { url: url };

        if (opts) {
          if (opts.title) {
            params.title = opts.title;
          }
          if (opts.description) {
            params.summary = opts.description;
          }
        }

        return LINKEDIN_BASE_SHARE_URL + '?' + $.param(params);
      },

      /**
       * Given an arbitrary url, generates a Twitter share window url.
       * @param {String} url Content url to share.
       * @param {Object} [opts] Meta information about url being shared. Will override any scraped meta from url.
       * @param {String} [opts.description] Tweet text of content being shared.
       * @returns {String} A generated Twitter share window url.
       */
      generateTwitterShareWindowUrl: function(url, opts) {
        var params = { url: url };

        if (opts) {
          if (opts.description) {
            params.text = opts.description;
          }

          if (opts.via) {
            params.via = opts.via;
          }
        }

        return TWITTER_BASE_SHARE_URL + '?' + $.param(params);
      },

      /**
       * Given an arbitrary url, generates a Facebook share window url.
       * @param {String} url Content url to share.
       * @returns {String} A generated Facebook share window url.
       */
      generateFacebookShareWindowUrl: function(url) {
        var params = { u: url};

        return FACEBOOK_BASE_SHARE_URL + '?' + $.param(params);
      },

      /**
       * Given an arbitrary url, generates a Pinterest share window url.
       * @param {String} url Content url to share.
       * @param {Object} [opts] Meta information about url being shared. Will override any scraped meta from url.
       * @param {String} [opts.title] Title of content being shared.
       * @param {String} [opts.description] Description of content being shared.
       * @param {String} [opts.imageUrl] Image preview of content being shared.
       * @returns {String} A generated Pinterest share window url.
       */
      generatePinterestShareWindowUrl: function(url, opts) {
        var params = { url: url };

        if (opts) {
          if (opts.title) {
            params.title = opts.title;
          }
          if (opts.description) {
            params.description = opts.description;
          }
          if (opts.imageUrl) {
            params.media = opts.imageUrl;
          }
        }

        return PINTEREST_BASE_SHARE_URL + '?' + $.param(params);
      },

      /**
       * Takes in a normalized service name and maps it to a local share window url generator
       * @param {String} serviceName a normalized service name e.g. 'LinkedIn', 'Twitter', 'Facebook', 'GooglePlus'
       * @param {String} url Content url to share.
       * @param {Object} [opts] Meta information about url being shared. Will override any scraped meta from url.
       * @param {String} [opts.title] Title of content being shared.
       * @param {String} [opts.description] Description of content being shared.
       * @param {String} [opts.imageUrl] Image preview of content being shared.
       * @returns {String} A generated share window url for the requested service.
       */
      generateShareWindowUrl: function(serviceName, url, opts) {
        var funcName = 'generate' + serviceName + 'ShareWindowUrl';
        return this[funcName](url, opts);
      }
    };

  ss.utils.exports('socialShareUtil', socialShareUtil);
}(window.slideshare_object));
